module.exports = __webpack_public_path__ + "img/score-sun.92520e94.svg";